/* Gogo Textos de Lenguaje

Tabla de Contenido

01.General
02.Inicio de sesión de usuario, cierre de sesión, registro
03.Menú
04.Tableros
05.Esquemas
06.Aplicaciones
  06.01.Chatea
  06.02.Encuesta
  06.03.Notas
07.IU
  07.01.Alertas
  07.02.Badges
  07.03.Botones
  07.04.Tarjetas
  07.05.Carrusel
  07.06.Gráficos
  07.07.Colapso
  07.08.Desplegables
  07.09.Editores
  07.10.Formularios
  07.11.Componentes
  07.12.Iconos
  07.13.Grupos de Entrada
  07.14.Jumbotron
  07.15.Modal
  07.16.Navegación
  07.17.Tooltips y Popovers
  07.18.Ordenable
  07.19.Maps
  07.20.Tables
*/

const chMessages = {
  /* 01.General */
  'general.copyright': 'Myma.ai © 2019 All Rights Reserved.',

  'user.login-title': '登入',
  'user.register': '註冊',
  'user.forgot-password': '忘記密碼',
  'user.email': '電郵',
  'user.newpassword': '新密碼',
  'user.currentpassword': '目前密碼',
  'user.newpasswordagain': '再次輸入新密碼',
  'user.password': '密碼',
  'user.forgot-password-question': '忘記密碼？',
  'user.fullname': '全名',
  'user.firstname': '名字',
  'user.lastname': '姓氏',
  'user.login-button': '登入',
  'user.register-button': '註冊',
  'user.reset-password-button': '重設',
  'user.buy': '購買',
  'user.username': '用戶名',

  /* 03.Menu */
  'menu.app': '主頁',

  'menu.default': '預設',
  'menu.analytics': '分析',
  'menu.ecommerce': '電子商務',
  'menu.content': '內容',
  'menu.pages': '頁面',
  'menu.data-list': '資料列表',
  'menu.thumb-list': '縮圖列表',
  'menu.image-list': '圖片列表',
  'menu.details': '詳細內容',
  'menu.search': '搜尋',
  'menu.login': '登入',
  'menu.register': '註冊',
  'menu.forgot-password': '忘記密碼',
  'menu.error': '錯誤',
  'menu.applications': '應用程式',
  'menu.todo': '待辦事項',
  'menu.survey': '調查',
  'menu.chat': '聊天',
  'menu.ui': '用戶介面',
  'menu.edit': '編輯',
  'menu.alerts': '提示',
  'menu.badges': '徽章',
  'menu.buttons': '按鈕',
  'menu.cards': '卡片',
  'menu.carousel': '走馬燈',
  'menu.charts': '圖表',
  'menu.collapse': '摺疊',
  'menu.dropdowns': '下拉選單',
  'menu.editors': '編輯器',
  'menu.form-layouts': '表單版面',
  'menu.form-components': '表單元件',
  'menu.form-validations': '表單驗證',
  'menu.icons': '圖示',
  'menu.input-groups': '輸入群組',
  'menu.jumbotron': 'Jumbotron',
  'menu.modal': '模態框',
  'menu.navigation': '導航',
  'menu.popover-tooltip': '彈出提示',
  'menu.sortable': '可排序',
  'menu.tables': '表格',
  'menu.menu': '選單',
  'menu.subhidden': '次要隱藏',
  'menu.hidden': '隱藏',
  'menu.visible': '可見',
  'menu.maps': '地圖',
  'menu.landingpage': '登陸頁面',
  'menu.multipage-home': '多頁主頁',
  'menu.singlepage-home': '單頁主頁',
  'menu.about': '關於',
  'menu.auth-login': '認證登入',
  'menu.auth-register': '認證註冊',
  'menu.blog': '博客',
  'menu.blog-detail': '博客詳情',
  'menu.careers': '職位空缺',
  'menu.confirmation': '確認',
  'menu.contact': '聯絡',
  'menu.docs': '文件',
  'menu.features': '功能',
  'menu.prices': '價格',
  'menu.videos': '影片',
  'menu.mailing': '郵件',
  'menu.invoice': '發票',
  'menu.blank-page': '敬請期待…',
  'menu.types': '選單類型',
  'menu.levels': '選單層級',
  'menu.third-level-1': '第三層 1',
  'menu.third-level-2': '第三層 2',
  'menu.third-level-3': '第三層 3',

  /* 04.Dashboards */
  'dashboards.update': '更新',
  'dashboards.save': '儲存',
  'dashboards.saveSchedule': '儲存排程',
  'dashboards.pending-orders': '待處理訂單',
  'dashboards.completed-orders': '已完成訂單',
  'dashboards.refund-requests': '退款申請',
  'dashboards.new-comments': '新評論',
  'dashboards.sales': '銷售',
  'dashboards.orders': '訂單',
  'dashboards.refunds': '退款',
  'dashboards.recent-orders': '最新訂單',
  'dashboards.product-categories': '產品分類',
  'dashboards.cakes': '蛋糕',
  'dashboards.tickets': '門票',
  'dashboards.calendar': '日曆',
  'dashboards.best-sellers': '暢銷商品',
  'dashboards.per-session': '每場',
  'dashboards.profile-status': '個人資料狀態',
  'dashboards.payment-status': '付款狀態',
  'dashboards.work-progress': '工作進度',
  'dashboards.tasks-completed': '已完成任務',
  'dashboards.payments-done': '已付款項',
  'dashboards.order-stock': '訂單–庫存',
  'dashboards.categories': '分類',
  'dashboards.quick-post': '快速發佈',
  'dashboards.title': '標題',
  'dashboards.content': '內容',
  'dashboards.ticket-count': '門票數目',
  'dashboards.commonticketsubmission': '常見票務提交',
  'dashboards.category': '分類',
  'dashboards.save-and-publish': '儲存並發佈',
  'dashboards.top-viewed-posts': '瀏覽最多文章',
  'dashboards.posts': '文章',
  'dashboards.pending-for-publish': '待發佈',
  'dashboards.users': '使用者',
  'dashboards.on-approval-process': '審核中',
  'dashboards.alerts': '提示',
  'dashboards.waiting-for-notice': '等待通知',
  'dashboards.files': '檔案',
  'dashboards.pending-for-print': '待列印',
  'dashboards.logs': '紀錄',
  'dashboards.gogo': 'GOGO',
  'dashboards.connect': '連接',
  'dashboards.magic-is-in-the-details': '細節出魔法',
  'dashboards.yes-it-is-indeed': '確實如此！',
  'dashboards.advanced-search': '進階搜尋',
  'dashboards.toppings': '配料',
  'dashboards.type': '類型',
  'dashboards.keyword': '關鍵字',
  'dashboards.search': '搜尋',
  'dashboards.top-rated-items': '高評價項目',
  'dashboards.country': '國家',
  'dashboards.webVisitors': '網站訪客',
  'dashboards.avatarClicks': '頭像點擊',
  'dashboards.wordCloud': '文字雲',
  'dashboards.topic': '主題',
  'dashboards.name': '名稱',
  'dashboards.button': '按鈕',
  'dashboards.visits': '訪問',
  'dashboards.checkAvailability': '查看可用性或價格',
  'dashboards.details': '詳情',
  'dashboards.roomsAvailability': '客房與可用性',
  'dashboards.startChat': '開始對話',
  'dashboards.restaurantsBars': '餐廳與酒吧',
  'dashboards.groupBooking': '團體預訂',
  'dashboards.promotions': '促銷活動',
  'dashboards.weedingevents': '婚禮與活動',
  'dashboards.lostsomething': '丟失物品',
  'dashboards.producttext': '產品文字',
  'dashboards.bookingroomnew': '預訂新房間',
  'dashboards.email': '電郵',
  'dashboards.phone': '電話',
  'dashboards.zipcode': '郵遞區號',
  'dashboards.marketingconsent': '市場推廣同意',
  'dashboards.additionalinfo': '額外資訊',
  'dashboards.viewallcontacts': '查看所有聯絡人',
  'dashboards.current': '當前',
  'dashboards.last7days': '過去7天',
  'dashboards.last30days': '過去30天',
  'dashboards.thisweek': '本週',
  'dashboards.thismonth': '本月',
  'dashboards.previousmonth': '上個月',
  'dashboards.yeartodate': '本年迄今',
  'dashboards.lastyear': '去年',
  'dashboards.all': '全部',
  'dashboards.standardOccupancy': '標準入住人數',
  'dashboards.max-occupancy': '最多容納人數',
  'dashboards.numberOfThisType': '此類型的數量',
  'dashboards.displayOrder': '顯示順序',
  'dashboards.provider': '提供者',
  'dashboards.edit': '編輯',
  'dashboards.delete': '刪除',
  'dashboards.addImages': '新增圖片',
  'dashboards.location_ip': '位置為基於 IP 地址的估算',
  'dashboards.near': '附近',
  'dashboards.referral': '使用者由此網站訪問你的頁面',
  'dashboards.calling_party': '主叫使用者',
  'dashboards.called_party': '被叫使用者',
  'dashboards.lastdial': '最後撥號',
  'dashboards.imagelink': '圖像連結',
  'dashboards.browsegallery': '瀏覽圖庫',
  'dashboards.changelog': '更改記錄',
  'dashboards.externalresources': '外部資源',
  'dashboards.webpage': '網頁',
  'dashboards.web-pages': '網頁',
  'dashboards.published': '已發佈',
  'dashboards.adddocument': '新增文件',
  'dashboards.ready-to-publish': '準備發佈',
  'dashboards.draft': '草稿',
  'dashboards.order-by': '排序方式',
  'dashboards.add-faq': '新增常見問題',
  'dashboards.collections': '收藏集',
  'dashboards.items': '項目',
  'dashboards.rooms-availability': '房間及可用性',
  'dashboards.events-wedding-venues': '活動及婚禮場地',
  'dashboards.long-stay-enquiry': '長期住宿查詢',
  'dashboards.reservation-confirmation-request': '預訂確認請求',
  'dashboards.modify-cancel-booking': '修改或取消預訂',
  'dashboards.left-something-behind': '遺留物品',
  'dashboards.invoice-copy': '發票 / 收據副本',
  'dashboards.sync': '同步',
  'dashboards.syncNow': '立即同步',
  'dashboards.add-web-page': '新增網頁',
  'dashboards.sprint-title':
    '認識 Sprint，我們突破性的自動化工具，能以十分之一的時間訓練 AI 模型。',
  'dashboards.sprint-description':
    'Sprint 與您並肩工作 — 釋放創意、提升生產力，並大幅減少訓練數碼助理所需的時間。',
  'dashboards.sprint-feature':
    'Sprint 功能旨在同步來自外部來源的知識，對於初始設置及持續數據更新均非常有用。當在活躍系統上執行時，Sprint 會根據您配置的外部來源修改知識中心，直接影響 AI 生成的行為和回應。如需有關 Sprint 設置的協助，請聯絡我們的支援團隊。',
  'dashboards.change-password': '更改密碼',
  'dashboards.sign-out': '登出',
  'dashboards.privacy-policy': '私隱政策',
  'dashboards.help-center': '協助中心',
  'dashboards.switch-account': '切換帳戶',
  'dashboards.business-settings': '業務設定',
  'dashboards.notifications-allowed': '允許通知',
  'dashboards.dark-theme': '深色主題',
  'dashboards.online': '在線',
  'dashboards.offline': '離線',
  'dashboards.invoice-&-payments': '發票及付款',
  'dashboards.upgrade-plan': '升級計劃',
  'dashboards.add-room': '新增房間',
  'dashboards.room-type': '房間類型',
  'dashboards.room-name': '房間名稱',
  'dashboards.how-many-guests': '每間房的總人數',
  'dashboards.number-of-rooms-this-type': '房間數量',
  'dashboards.number-of-bedrooms': '睡房數量',
  'dashboards.number-of-livingrooms': '客廳數量',
  'dashboards.minimum-adults': '最少成年人',
  'dashboards.maximum-adults': '最多成年人',
  'dashboards.maximum-children': '最多兒童',
  'dashboards.maximum-infants': '最多嬰兒',
  'dashboards.extra-beds-allowed': '允許加床',
  'dashboards.booking-engine-code': '預訂系統代碼',
  'dashboards.room-size': '房間面積',
  'dashboards.balcony-area': '露台面積',
  'dashboards.unit': '單位',
  'dashboard.whatsapp_message': '在此輸入您的訊息...',
  'dashboard.whatsapp_reply_window':
    '從客戶最後一次發送訊息起，您有 24 小時的時間在 WhatsApp Business 上回覆客戶訊息。若您在這 24 小時的客戶服務時段內回覆，則可以發送任何類型的訊息。24 小時結束後，您只能使用事先核准的訊息範本發送訊息，並在客戶回覆時重新啟動 24 小時時段。',
  'dashboards.square-meters': '平方米',
  'dashboard.pick_quick_reply': '選擇快速回覆或輸入你的訊息',
  'dashboard.hang_in_there': '請稍候，我們正在嘗試為你連線！',
  'dashboard.outbound_msg': '發送外發訊息的時間',
  'dashboard.message_sent': '你的訊息已成功發送！',
  'dashboard.failed_msg': '訊息發送失敗',
  'dashboard.new_chat_message': '新的聊天訊息',
  'dashboard.user_msg':
    '在過去 24 小時內已有用戶訊息，你可以回覆任何訊息。你仍然要發送此範本訊息，還是改為回覆其他訊息？',
  'dashboard.us_number':
    '由於 Meta 於 2025 年 4 月 1 日暫停向美國號碼發送所有行銷訊息，因此 WhatsApp Business 訊息不會發送至美國號碼。',
  'dashboard.error_msg': '請正確填寫所有佔位符。',

  'web-widget.title': '網站聊天機器人的網頁小工具選單',

  /*Home page*/
  'dashboards.quickstartwithai': 'AI 快速入門',
  'dashboards.fastestpathtoautomation':
    '您正處於使用 AI 工具進行自動化的最快路徑',
  'dashboards.insightsthatempower': '賦能洞察',
  'dashboards.trainchatbot': '訓練聊天機器人',
  'dashboards.automatewithforms': '通過表單自動化',
  'dashboards.inroomdigitalcompendium': '房內數碼指南',
  'dashboards.support': '支援',
  'dashboards.helpcenter': '說明中心',
  'dashboards.searchfaqintegrations': '搜尋有關常見問答、整合等文章。',
  'dashboards.asklivechat': '透過線上聊天向我們的團隊提問',
  'dashboards.inroomqrcode': '房內 QR 碼查看物業及地點資訊',
  'dashboards.customizewebwidget':
    '自訂並將 Web Widget 添加至您的網站，內建 AI 聊天機器人',
  'dashboards.createcustomforms': '建立自訂表單並在客人提交時接收通知',
  'dashboards.trainchatbotproperty':
    '使用關於物業（如入住時間、設施等）的資訊訓練 Chatbot',
  'dashboards.chatbotinsights':
    '查看您的 Chatbot 如何與客人互動，並獲得有關網站訪客、常見問題等統計洞察',
  'dashboards.addaichatbottoyourwebsite': '將 AI 聊天機器人添加至您的網站',
  'dashboards.addaichatbottoyourwebsite': '将 AI 聊天机器人添加到您的网站',

  /* Email Stats */
  'dashboards.thread-summary-title': '討論串摘要',
  'dashboards.thread-summary-subtitle': '由 AI 生成的電郵摘要',
  'dashboards.ai-replies-title': 'AI 回覆',
  'dashboards.ai-replies-subtitle': '由 AI 生成的回覆',
  'dashboards.total-thread-summary-title': '已生成討論串摘要總數',
  'dashboards.total-ai-replies-title': '已生成 AI 回覆總數',
  'dashboards.total-draft-copied': '草稿由用戶複製',
  'dashboards.urgency': '緊急程度',
  'dashboards.sentiment': '情緒',
  'dashboards.common-email-reasons': '常見電郵原因',
  'dashboards.topics-in-emails': '電郵主題',
  'dashboards.email-assistant-usage': 'AI 電郵助理使用情況',
  'dashboards.usage-by-email-address': '按電郵地址使用情況',

  /* 05.Pages */
  'pages.title.dashboards.analytics': '分析',
  'pages.title.ari': '供應與價格',
  'pages.title.conversations': '會話',
  'pages.title.bookings': '預訂與訂房',
  'pages.title.tickets': '潛在客與查詢',
  'pages.title.propinfo': '回應',
  'pages.title.discounts': '折扣與優惠活動',
  'pages.title.finance': '財務',
  'pages.title.integration': '整合',
  'pages.title.admin': '管理員',
  'pages.add-new': '新增',
  'pages.add-new-modal-title': '新增項目',
  'pages.display-options': '顯示選項',
  'pages.orderby': '排序方式：',
  'pages.product-name': '產品名稱',
  'pages.category': '類別',
  'pages.description': '描述',
  'pages.status': '狀態',
  'pages.cancel': '取消',
  'pages.submit': '提交',
  'pages.delete': '刪除',
  'pages.another-action': '其他操作',
  'pages.actions': '操作',
  'pages.header': '標題欄',
  'pages.details': '詳情',
  'pages.orders': '訂單',
  'pages.rating': '評分',
  'pages.price': '價格',
  'pages.ingredients': '材料',
  'pages.is-vegan': '全素',
  'pages.order-status': '訂單狀態',
  'pages.bake-progress': '烘焙進度',
  'pages.popularity': '受歡迎程度',
  'pages.comments': '評論',
  'pages.error-title': '喔……似乎發生錯誤！',
  'pages.error-code': '錯誤代碼',
  'pages.go-back-home': '返回主頁',
  'pages.mailing-info':
    '郵件範本使用內嵌樣式和表格佈局，以適應不同郵件提供商的顯示。為提升可用性，我們以一般 HTML（dangerouslySetInnerHTML）方式納入。',
  'pages.invoice-info':
    '發票範本提供可在專案外使用的內嵌樣式版本，亦有 React 版本。',
  'pages.react-version': 'React 版本',
  'pages.inline-version': '內嵌樣式 HTML 版本',

  /* 06.Applications */

  /* 06.01.Chat */
  'chat.messages': '讯息',
  'chat.contacts': '联系人',
  'chat.saysomething': '说些什么..',

  /* 06.02.Survey */
  'survey.delete': '刪除',
  'survey.edit': '編輯',
  'survey.add-new': '新增',
  'survey.add-new-title': '新增調查',
  'survey.title': '標題',
  'survey.category': '類別',
  'survey.label': '標籤',
  'survey.status': '狀態',
  'survey.cancel': '取消',
  'survey.submit': '提交',
  'survey.another-action': '其他操作',
  'survey.display-options': '顯示選項',
  'survey.orderby': '排序方式：',
  'survey.all-surveys': '所有調查',
  'survey.completed-surveys': '已完成調查',
  'survey.categories': '類別',
  'survey.active-surveys': '進行中調查',
  'survey.labels': '標籤',

  /* 06.03.Todo */
  'todo.add-new': '新增',
  'todo.add-new-title': '新增待辦事項',
  'todo.title': '標題',
  'todo.detail': '詳細內容',
  'todo.category': '類別',
  'todo.label': '標籤',
  'todo.status': '狀態',
  'todo.cancel': '取消',
  'todo.submit': '提交',
  'todo.action': '操作',
  'todo.another-action': '其他操作',
  'todo.display-options': '顯示選項',
  'todo.orderby': '排序方式：',
  'todo.all-tasks': '所有任務',
  'todo.pending-tasks': '待完成任務',
  'todo.completed-tasks': '已完成任務',
  'todo.categories': '類別',
  'todo.labels': '標籤',

  /* 07.01.Alerts */
  'alert.rounded': '圓角提醒',
  'alert.react-notifications': 'React 提示訊息',
  'alert.outline': '外框',
  'alert.primary': '主要',
  'alert.secondary': '次要',
  'alert.info': '資訊',
  'alert.success': '成功',
  'alert.warning': '警告',
  'alert.error': '錯誤',
  'alert.filled': '填滿',
  'alert.primary-text': '這是一條主要提醒 —— 請留意！',
  'alert.secondary-text': '這是一條次要提醒 —— 請留意！',
  'alert.success-text': '這是一條成功提醒 —— 請留意！',
  'alert.danger-text': '這是一條危險提醒 —— 請留意！',
  'alert.warning-text': '這是一條警告提醒 —— 請留意！',
  'alert.info-text': '這是一條資訊提醒 —— 請留意！',
  'alert.light-text': '這是一條亮色提醒 —— 請留意！',
  'alert.dark-text': '這是一條暗色提醒 —— 請留意！',
  'alert.default': '預設提醒',
  'alert.dismissing': '可關閉提醒',
  'alert.dismissing-text': '天啊瓜啦！你應該檢查一下下方的欄位。',
  'alert.dismissing-without-animate-text':
    '我是一條提醒，點一下即可關閉，不設動畫！',

  /* 07.02.Badges */
  'badge.sizes': '尺寸',
  'badge.colors': '顏色',
  'badge.outline': '外框',
  'badge.links': '連結',
  'badge.counter-badges': '數字徽章',
  'badge.bootstrap-default': 'Bootstrap 預設',
  'badge.primary': '主要',
  'badge.secondary': '次要',
  'badge.success': '成功',
  'badge.danger': '危險',
  'badge.warning': '警告',
  'badge.info': '資訊',
  'badge.light': '亮色',
  'badge.dark': '暗色',

  /* 07.03.Buttons */
  'button.default': 'Bootstrap 預設',
  'button.colors': '顏色',
  'button.rounded': '圓角',
  'button.outline': '外框',
  'button.states': '狀態',
  'button.sizes': '尺寸',
  'button.button-groups': '按鈕群組',
  'button.large-button': '大型按鈕',
  'button.small-button': '小型按鈕',
  'button.extra-small-button': '超小按鈕',
  'button.block-button': '區塊按鈕',
  'button.active': '啟動',
  'button.disabled': '停用',
  'button.basic': '基本',
  'button.toolbar': '工具欄',
  'button.nesting': '嵌套',
  'button.vertical-variation': '垂直變化',
  'button.checkbox-radio-button': '複選框與單選按鈕',
  'button.checkbox': '複選框',
  'button.radio': '單選按鈕',
  'button.radio-button': '單選按鈕',
  'button.primary': '主要',
  'button.secondary': '次要',
  'button.success': '成功',
  'button.danger': '危險',
  'button.warning': '警告',
  'button.info': '資訊',
  'button.light': '亮色',
  'button.dark': '暗色',
  'button.states-text':
    '這個按鈕會先顯示一個旋轉圖示 2 秒，再顯示錯誤圖示 3 秒，然後恢復正常狀態。',
  'button.click-here': '按此點擊',
  'button.states-text-alternate':
    '這個按鈕會先顯示一個旋轉圖示 2 秒，再顯示錯誤圖示 3 秒，然後恢復正常狀態。',
  'button.primary-link': '主要連結',
  'button.link': '連結',
  'button.primary-button': '主要按鈕',
  'button.button': '按鈕',
  'button.left': '左',
  'button.middle': '中',
  'button.right': '右',
  'button.dropdown': '下拉',
  'button.dropdown-link': '下拉連結',

  /* 07.04.Cards */
  'cards.icon-card': '圖示卡片',
  'cards.image-card': '圖片卡片',
  'cards.image-overlay-card': '圖片覆蓋卡片',
  'cards.image-card-list': '圖片卡片列表',
  'cards.tab-card': '分頁卡片',
  'cards.user-card': '使用者卡片',

  /* 07.05.Carousel */
  'carousel.basic': '一般走馬燈',
  'carousel.single': '單一走馬燈',
  'carousel.without-controls': '無控制項走馬燈',

  /* 07.06.Charts */
  'charts.line': '折線圖',
  'charts.polar': '極地圖',
  'charts.area': '面積圖',
  'charts.scatter': '散點圖',
  'charts.bar': '長條圖',
  'charts.radar': '雷達圖',
  'charts.pie': '圓餅圖',
  'charts.doughnut': '環型圖',
  'charts.shadow': '有陰影',
  'charts.no-shadow': '無陰影',

  /* 07.07.Collapse */
  'collapse.basic': '基本',
  'collapse.toggle': '切換',
  'collapse.accordion': '手風琴',
  'collapse.controlled': '受控',
  'collapse.uncontrolled': '不受控',

  /* 07.08.Dropdowns */
  'dropdowns.basic': '基本',
  'dropdowns.controlled': '受控',
  'dropdowns.uncontrolled': '不受控',
  'dropdowns.dropdown': '下拉選單',
  'dropdowns.header': '標題',
  'dropdowns.action': '操作',
  'dropdowns.another-action': '其他操作',
  'dropdowns.right': '右',
  'dropdowns.left': '左',
  'dropdowns.drop-directions': '下拉方向',
  'dropdowns.dropright': '右下拉',
  'dropdowns.dropleft': '左下拉',
  'dropdowns.small-button': '小按鈕',
  'dropdowns.large-button': '大按鈕',
  'dropdowns.sizing': '尺寸設定',
  'dropdowns.split-button': '分割按鈕下拉',
  'dropdowns.dropup': '上拉選單',

  /* 07.09.Editors */
  'editors.draftjs': 'Draft.js 編輯器',
  'editors.quill-standart': 'Quill 標準',
  'editors.quill-bubble': 'Quill 泡泡',

  /* 07.10.Forms */
  'forms.basic': '基本',
  'forms.email': '電郵',
  'forms.email-muted': '我們絕不會與他人分享您的電郵。',
  'forms.password': '密碼',
  'forms.submit': '提交',
  'forms.horizontal': '水平',
  'forms.radios': '單選按鈕',
  'forms.first-radio': '第一個選項',
  'forms.second-radio': '第二個選項',
  'forms.third-radio-disabled': '第三個選項（已停用）',
  'forms.checkbox': '複選框',
  'forms.signin': '登入',
  'forms.top-labels-over-line': '標題在上方',
  'forms.tags': '標籤',
  'forms.date': '日期',
  'forms.state': '州／省',
  'forms.top-labels-in-input': '標籤置於輸入框內',
  'forms.email-u': '電郵',
  'forms.password-u': '密碼',
  'forms.tags-u': '標籤',
  'forms.date-u': '日期',
  'forms.state-u': '州／省',
  'forms.grid': '表單格線',
  'forms.address': '地址',
  'forms.address2': '地址 2',
  'forms.city': '城市',
  'forms.city-message': '請選擇城市！',
  'forms.state-message': '請選擇州／省！',
  'forms.zip': '郵政編碼',
  'forms.signup': '註冊',
  'forms.inline': '內聯',
  'forms.validation-availity': 'Availity Reactstrap 驗證',
  'forms.validation-formik': 'Formik 驗證',
  'forms.default': '預設',
  'forms.firstname': '名字',
  'forms.firstname-message': '請輸入您的名字！',
  'forms.lastname': '姓氏',
  'forms.lastname-message': '請輸入您的姓氏！',

  /* 07.11.Form Components */
  'form-components.custom-inputs': '自定義輸入',
  'form-components.checkboxes': '複選框群組',
  'form-components.radios': '單選按鈕群組',
  'form-components.inline': '內聯',
  'form-components.react-select': 'React Select',
  'form-components.state-single': '單一選擇',
  'form-components.state-multiple': '多重選擇',
  'form-components.react-autosuggest': 'React 自動建議',
  'form-components.date-picker': '日期選擇器',
  'form-components.date': '日期',
  'form-components.date-range': '日期範圍',
  'form-components.date-with-time': '日期與時間',
  'form-components.embedded': '內嵌',
  'form-components.dropzone': '拖放區',
  'form-components.drop-files-here': '拖放文件至此',
  'form-components.tags': '標籤',
  'form-components.switch': '開關',
  'form-components.primary': '主要',
  'form-components.secondary': '次要',
  'form-components.primary-inverse': '主要（反向）',
  'form-components.secondary-inverse': '次要（反向）',
  'form-components.slider': '滑桿',
  'form-components.double-slider': '雙滑桿',
  'form-components.single-slider': '單滑桿',
  'form-components.rating': '評分',
  'form-components.interactive': '互動式',
  'form-components.readonly': '唯讀',
  'form-components.type-a-cake': '輸入蛋糕名稱',
  'form-components.start': '開始',
  'form-components.end': '結束',
  'form-components.tables': '表格',

  /* 07.12.Icons */
  'icons.simplelineicons': 'Simple Line 圖示',
  'icons.iconsmind': 'Iconsmind 圖示',

  /* 07.13.Input Groups */
  'input-groups.basic': '基本',
  'input-groups.sizing': '尺寸設定',
  'input-groups.small': '小',
  'input-groups.default': '預設',
  'input-groups.large': '大',
  'input-groups.checkboxes-and-radios': '複選與單選',
  'input-groups.multiple-inputs': '多輸入',
  'input-groups.first-and-last-name': '姓名欄位',
  'input-groups.multiple-addons': '多附加元件',
  'input-groups.button-addons': '按鈕附加',
  'input-groups.button': '按鈕',
  'input-groups.buttons-with-dropdowns': '按鈕附下拉功能',
  'input-groups.dropdown': '下拉選單',
  'input-groups.header': '標題欄',
  'input-groups.action': '操作',
  'input-groups.another-action': '其他操作',
  'input-groups.custom-select': '自定義選擇',
  'input-groups.options': '選項',
  'input-groups.choose': '選擇…',
  'input-groups.custom-file-input': '自定義文件輸入',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': '你好，世界！',
  'jumbotron.lead':
    '這是一個簡單的主題單元，一個 jumbotron 風格的元件，用來吸引注意重點內容。',
  'jumbotron.lead-detail':
    '它使用實用工具類別來調整排版與間距，讓內容在較大的容器中有良好的佈局。',
  'jumbotron.learn-more': '了解更多',

  /* 07.15.Modal */
  'modal.basic': '基本',
  'modal.modal-title': '視窗標題',
  'modal.launch-demo-modal': '啟動示範視窗',
  'modal.scrolling-long-content': '長內容滾動',
  'modal.backdrop': '背景遮罩',
  'modal.backdrop-value': '遮罩值',
  'modal.right-modal': '右側視窗',
  'modal.launch-right-modal': '啟動右側視窗',
  'modal.nested-modal': '巢狀視窗',
  'modal.size': '大小',
  'modal.launch-large-modal': '啟動大型視窗',
  'modal.launch-small-modal': '啟動小型視窗',

  /* 07.16.Navigation */
  'nav.basic': '基本導航',
  'nav.active': '啟用',
  'nav.disabled': '停用',
  'nav.disabled-link': '停用連結',
  'nav.link': '連結',
  'nav.longer-link': '較長的導航連結',
  'nav.another-link': '另一個連結',
  'nav.right': '靠右',
  'nav.dropdown': '下拉選單',
  'nav.header': '標題',
  'nav.action': '操作',
  'nav.another-action': '另一個操作',
  'nav.horizontal-alignment': '導航水平對齊',
  'nav.vertical-alignment': '導航垂直對齊',
  'nav.pills': '導航藥丸樣式',
  'nav.fill-justify': '導航填充與兩端對齊',
  'nav.pills-dropdowns': '帶下拉選單的藥丸導航',
  'nav.pagination-basic': '基本分頁',
  'nav.pagination-sizing': '分頁大小',
  'nav.large': '大型',
  'nav.small': '小型',
  'nav.center': '置中',
  'nav.pagination-alignment': '分頁對齊',
  'nav.breadcrumb-basic': '基本麵包屑',

  /* 07.17.Popover & Tooltip */
  'popover-tooltip.popover': '彈出框',
  'popover-tooltip.tooltip': '提示框',

  /* 07.18.Sortable */
  'sortable.columns': '可排序欄位',
  'sortable.basic': '基本',
  'sortable.handles': '拖動手柄',

  /* 07.19.Maps */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'Bootstrap 表格',
  'table.bootstrap-basic': '基本表格',
  'table.bootstrap-striped': '條紋列',
  'table.bootstrap-bordered': '有框表格',
  'table.bootstrap-borderless': '無框表格',
  'table.bootstrap-hoverable': '可懸停列',
  'table.bootstrap-responsive': '響應式表格',
  'table.react-tables': 'React 表格',
  'table.react-pagination': '分頁',
  'table.react-scrollable': '可滾動',
  'table.react-advanced': '篩選、長度與跳轉',

  /* Property Info */
  'property-info.allcustomers': '所有客戶',
  'property-info.external-sources': '外部來源',
  'property-info.faq': '常見問題',
  'property-info.documents': '文件',
  'property-info.publish-ai': '發佈 AI',
  'property-info.pre-built-templates': '預建模板',
  'property-info.room-types': '房型',
  'property-info.about-property': '關於物業',
  'property-info.about-properties': '關於屬性',
  'property-info.facilities-services': '設施與服務',
  'property-info.property-facilities': '物業設施',
  'property-info.room-amenities': '客房設施',
  'property-info.property-contact': '物業聯絡人',
  'property-info.property-activities': '物業活動',
  'property-info.property-location': '物業位置',
  'property-info.about-rooms': '關於客房',
  'property-info.about-sites': '關於網站',
  'property-info.special-emergencies': '緊急情況',
  'property-info.gallery': '畫廊',
  'property-info.policies': '政策規定',
  'property-info.nearby': '附近',
  'property-info.transport': '運輸',
  'property-info.location': '地點',
  'property-info.about-rhproperty': '關於退休之家',
  'property-info.related-topics': '相關話題',
  'property-info.assistant-options': '助理選項',
  'property-info.restaurant-assistant-information': '餐廳信息',
  'property-info.restaurant-assistant-options': '歡迎辭',
  'property-info.channel-messages': '頻道消息',
  'property-info.icon.gallery': '圖標庫',
  'property-info.copilot': '副駕駛',
  'property-info.sprint': '短跑',
  'property-info.home-information': '首頁信息',
  'property-info.loction': '地點',
  'property-info.rooms-and-images': '房間和圖片',
  'property-info.trainig-data': '訓練數據',
  'property-info.flows': '流量',
  'property-info.add-your-own': '添加您自己的',
  'property-info-utility-miscellaneous': '各種各樣的',
  'property-info-utility-payment': '付款方式',
  'property-info-utility-broadband': '寬頻',
  'property-info-utility-emergency': '緊急狀況',
  'property-info-utility-mobile': '移動的',
  'property-info-utility-moving': '移動',
  'property-info.publishMonitor': '發布與監控',
  'property-info.webWidget': '網頁小工具',
  'property-info.media': '媒體',
  /** Rate & Promo */
  'rate-promo.rate-plans': '收費計劃',
  'rate-promo.rate-plan-addons': '附加組件',
  'rate-promo.rate-plan-promos': '宣傳片',

  'title.property-information': '物業資訊',

  'property.message': '信息',
  'property.example': '例子',
  'property.link': '鏈接',
  'property.image-carousel': '圖像輪播',
  'property.Title': '標題',
  'property.SubTitle': '副標題',

  'property.add-invoke-api': '呼叫API',
  'property.add-message-button': '新增訊息',
  'property.add-img-button': '新增圖片',
  'property.add-link-button': '添加鏈接',
  'property.add-herocard-button': '添加英雄卡',
  'property.add-api-button': '添加按鈕',

  'menu.settings': '設定',
  'menu.workflows': '工作流程',
  'menu.product_services': '產品與服務',
  'menu.product_recommander': '產品推薦器',
  'menu.digital_guide_book': '數字指南書',
  'menu.welcome_message': '歡迎訊息',

  'menu.about-property': '關於物業',
  'menu.property-facilities': '物業設施',
  'menu.room-amenities': '客房設施',
  'menu.property-contact': '物業聯絡人',
  'menu.about-rooms': '關於客房',
  'menu.special-emergencies': '緊急情況',
  'menu.show-filter': '篩選',
  'menu.new': '新的',
  'menu.channel': '渠道',
  'menu.application': '應用程式',
  'menu.content-manager': '內容管理器',
  'menu.events-calendar': '事件日曆',
  'menu.appearance-settings': '外觀與設定',
  'menu.help': '幫助',
  'menu.myAccounts': '我的帳戶',

  'dashboards.send': '發送',
  'dashboards.hello': '你好',
  'dashboards.notificationsAllowed': '允許通知',
  'dashboards.allowNotifications': '允許通知',
  'dashboards.views': '查看次數',
  'dashboards.bookingURL': '預訂網址',
  'dashboards.searchTags': '搜尋標籤',
  'dashboards.searchCategoryTags': '搜尋分類標籤',
  'dashboards.bedroom': '睡房',
  'dashboards.addBedroom': '新增睡房',
  'dashboards.frequency': '頻率',
  'dashboards.includeSubpages': '包括子頁面',
  'dashboards.enableFaqs': '啟用常見問題',
  'dashboards.faqsDescription':
    '啟用常見問題後，您可以輸入問題，系統會從網頁內容中提取相應答案以創建完整的常見問題',
  'dashboards.faq': '常見問題',
  'dashboards.deleteDocument': '刪除文件',
  'dashboards.confirmDelete': '您確定要刪除嗎？',
  'dashboards.addItem': '新增項目',
  'dashboards.addFirstWebPage': '新增您的第一個網頁',

  'dashboards.popular-compendium': '熱門彙編選單項目',
  'dashboards.wordcloudofcompendium': '彙編選單項目的文字雲',
  'dashboards.wordcloudonthings': '訪客提問及選單項目的文字雲',
  'dashboards.common-asked': '常見問題',
  'dashboards.website-visitor-asking': '網站訪問者在問的事情',
  'dashboards.visit-country': '網站訪問國家（地區）',
  'dashboards.visit-traffic': '網站流量的國家',
  'dashboards.rooms-product': '房間和產品',
  'dashboards.popular-room-product': '受歡迎的房間和產品',

  'dashboards.messenger-stats': '人氣菜品',
  'dashboards.messenger-stats-topic-view': '菜單項視圖的統計信息',
  'dashboards.messenger-stats-visits': '菜單項視圖',
  'dashboards.opening-menu-items': '打開菜單項的網站訪問者數量',

  'dashboards.number-totalavatarclick': '頭像總點擊次數',

  'dashboards.clicks': '點擊次數',
  'dashboards.leads': '線索',
  'dashboards.hours': '小時',
  'dashboards.minutes': '分鐘',
  'dashboards.subscribe-to-reports': '訂閱報告',
  'dashboards.ai-chatbot': '人工智能聊天机器人',
  'dashboards.compendium': '概要',
  'dashboards.compendium-digital-usage': '數字綱要的使用',
  'dashboards.compendium-unique-visits': '二維碼掃描/點擊',
  'dashboards.compendium-opening-menu-items': '查看的選單項目數',
  'dashboards.compendium-total-digital-clicks': '選單項目總瀏覽量',
  'dashboards.compendium-total-qr-code': '二維碼掃描/點擊總數',
  'dashboards.compendium-avg-menu-items': '每次掃描的平均選單項目瀏覽量',
  'dashboards.top-clicked-urls': '最多點擊的網址',
  'dashboards.top-clicked-urls-description': '網址點擊分析',
  'dashboards.urls': '網址',
  'dashboards.externalDeleteMessage':
    '此文件是從外部來源生成的。如果您不希望它再次被建立，請確保同時移除相關的同步排程。',
  'dashboards.deleteAndGoToExternalSources': '刪除並前往外部來源',
  'dashboards.tickets-by-category': '按類別劃分的票證',
  'dashboards.download': '下載',
  'property.delete': '刪除',
  'menu.userroles': '用戶和角色',
  'menu.members': '會員',
  'menu.guest-pass': '來賓證',
  'menu.ratebookings': '房價和預訂',
  'dashboards.engagement-time': '數字助理參與時間',
  'dashboards.conversations-minutes':
    '總分鐘數和過夜（晚上 7 點至早上 7 點）對話分鐘數',
  'dashboards.visitor-questions': '訪客問題',
  'dashboards.recent-queries': '最近查詢',
  'dashboards.visitor-saying': '您的訪客對數字助理說的是什麼',
  'dashboards.contacts-prechatform-leavemessage':
    '聊天前表格和留言中存儲的聯繫人',
  'menu.dashboards': '見解',
  'menu.ari': '可用性和價格',
  'menu.conversations': '對話內容',
  'menu.conversations.unified-inbox': '統一收件匣',
  'menu.conversations.active': '活躍聊天',
  'menu.conversations.archives': '檔案',
  'menu.conversations.missed-responses': '錯過回复',
  'menu.conversations.ticket': '門票',
  'menu.conversations.reply-templates': '回复模板',
  'menu.bookings': '預訂與訂座',
  'menu.tickets': '潛在客戶與門票',
  'menu.propinfo': '知識中心',
  'menu.rate-promos': '利率與促銷',
  'menu.finance': '金融',
  'menu.integration': '連接',
  'menu.admin': '管理員與安全性',
  'menu.favourites': '收藏夾',
  'menu.recommender': '對話流程',
  'menu.assistant-setup': '助理設置',
  'menu.admin-insights': '管理洞察',
  'menu.super-admin': '超管理員',
  'menu.groups': '團體',
  'menu.properties': '特性',
  'menu.service-provider': '服務提供者',
  'menu.spaces': '空間',
  'menu.availability': '可用性',
  'menu.guest-messaging': '客人訊息',
  'dashboards.space-booking': '艙等預訂',
  'dashboards.gift-voucher': '禮券',
  'dashboards.chatbots': '聊天機器人',
  'dashboards.form': '從',
  'dashboards.to': '到',
  'dashboards.active-groups': '活躍團體',
  'dashboards.active-properties': '活躍屬性',
  'dashboards.live-properties': '即時屬性',
  'dashboards.properties-going': '按日期範圍上線的屬性',
  'dashboards.start-date': '開始日期',
  'dashboards.end-date': '結束日期',

  'dashboards.website-visits': '網站訪問',
  'dashboards.unique-visitors': '不重複訪客',
  'dashboards.last-week': '上個星期',
  'dashboards.this-week': '本星期',
  'dashboards.this-month': '這個月',
  'dashboards.previous-month': '前一個月',
  'dashboards.yeartodate': '今年迄今為止',
  'dashboards.lastyear': '去年',
  'dashboards.last-7-days': '最近7天',
  'dashboards.last-30-days': '最近30天',
  'dashboards.last-60-days': '最近60天',
  'dashboards.last-90-days': '最近90天',
  'dashboards.conversion-rates': '轉換率',
  'dashboards.digital-assistant-engagement': '數字助理互動',
  'dashboards.total-overnight-conversations':
    '總和過夜（晚上 7 點至早上 7 點）對話',
  'dashboards.percentage-accuracy': '知識覆蓋範圍',
  'dashboards.percentage-conversion': '網站流量到聊天的轉化',
  'dashboards.percentage-avatarclick': '網站流量與頭像點擊量',
  'dashboards.percentage-negativefeedback': '負面回饋佔頭像點擊的百分比',
  'dashboards.percentage-amenties': '便利設施查詢',
  'dashboards.percentage-booking': '訂票查詢',
  'dashboards.percentage-webchats': '網站聊天',
  'dashboards.percentage-facebookchat': 'Facebook聊天',
  //'dashboards.number-webchattime': '網絡聊天總時間',
  'dashboards.number-averagetimeconversation': '每次對話平均時間',

  'dashboards.number-webchattime': '總對話時間',
  'dashboards.number-totalconversation': '總對話',
  'dashboards.number-websiteconversation': '網站對話',
  'dashboards.number-facebookconversation': '臉書對話',
  'dashboards.number-estimatedtimesaving': '預計節省時間',
  'dashboards.number-googlemapsconversation': '谷歌地圖對話',
  'dashboards.number-whatsappconversation': 'WhatsApp 對話',
  'dashboards.number-instagramconversation': 'Instagram 對話',
  'dashboards.number-agentconversation': '代理對話',
  'dashboards.number-amenityqueries': '便利設施查詢',
  'dashboards.number-bookingenquiries': '預訂查詢',
  'dashboards.number-groupbookingenquiries': '團體預訂查詢',
  'dashboards.number-eventenquiries': '活動查詢',
  'dashboards.number-longstayenquiries': '長住查詢',
  'dashboards.number-totaltickets': '門票',
  'dashboards.number-returncustomer': '回頭客',
  'dashboards.number-redirects': '網站重定向',
  'dashboards.number-bookingengineleads': '預訂引擎線索',
  'dashboards.number-roomnightsreferred': '推薦的房晚',
  'dashboards.number-revenuereferred': '收入推薦',
  'menu.bookingsmenu': '訂票',
  'menu.guests': '賓客信息',
  'menu.whatsnew': '什麼是新的',

  'forms.forms-title': '形式',
  'menu.formbuilder': '表單生成器',
  'dashboards.trainAI': '使用文件訓練 AI',
  'dashboards.uploadDocuments':
    '上傳文件以協助您的 AI 了解您的業務並像您一樣協助客戶。您可以新增 .doc、.pdf 或 .txt 格式的檔案。',
  'dashboards.welcomeMessage': '歡迎訊息',
  'dashboards.personalizeGreeting':
    '個性化客戶的歡迎方式，以展現您的品牌、風格與禮儀，確保他們感受到最熱情的接待。自訂問候語以展現品牌並營造溫馨氛圍。',
  'dashboards.addRoomDetails':
    '新增每個房間的詳細資訊，讓旅客可以輕鬆發現他們需要的一切，以選擇最理想的房型，並使預訂流程更簡單、更快速。',
  'dashboards.trainAIFAQs': '透過常見問題訓練 AI',
  'dashboards.manualQuestions':
    '有些問題無法通過文件回答或在網站上找到。在這裡，您可以手動新增問題，以確保客戶始終擁有他們所需的信息在手邊。',
  'dashboards.publishAI': '發布 AI 以反映最新更新',
  'dashboards.retrainAfterChanges':
    '當您在知識中心或表單中進行更改時，務必使用更新後的資訊重新訓練聊天機器人。發布您的 AI 可確保聊天機器人提供最準確且最新的答案。',
  'dashboards.enhanceKnowledge': '透過追蹤未回覆的查詢來增強 AI 知識',
  'dashboards.reviewUnanswered':
    '每當 AI 無法回答問題或僅提供有限細節時，您會在此處看到這些查詢。檢查它們以識別知識中心中的缺口或客人獨有的問題。',
  'dashboards.manageMedia': '管理媒體',
  'dashboards.mediaGallery':
    '每當您上傳房間、設施、標誌或您的數位化身等圖像時，它們會顯示在此畫廊中，為您提供一個集中管理視覺內容的地方，並確保您的客人看到使您的業務獨特的部分。',
  'dashboards.createForms': '輕鬆建立表單並在每次提交時收到通知。',
  'dashboards.manageForms':
    '建立並管理表單以收集客戶資訊、設定通知，並為不同語言進行自訂。',
  'dashboards.personalizeResponse': '個性化回應風格及對話進展方式',
  'dashboards.controlConversation':
    '此進階功能使您能夠塑造並控制不同渠道中與客戶的對話展開方式。',

  'menu.virtualfrontdesk': '虛擬前台',
  'menu.guestservice': '客戶服務',
  'virtual-front.common-questions': '常見問題',
  'virtual-front.add-on-upsells': '附加組件和追加銷售',
  'virtual-front.service-order': '服務訂單',
  //'virtual-front.guest-service-add-on-upsells': "賓客服務和附加服務",
  'virtual-front.guest-service-add-on-upsells': '數字留言簿',
  'virtual-front.outbound': '出站',
  'virtual-messenger': '信使',

  'missed-response.missed-response-title': '錯過回复標題',
  //
  'content.allconversation': '所有對話',
  'content.active': '活躍',
  'content.tickets': '工單',
  'content.filter': '篩選',
  'content.createtickets': '創建工單',
  'content.conversation': '對話',
  'content.knowledgesearch': '知識搜索',
  'content.reply': '回覆',
  'content.visitorinfo': '訪客資訊',
  'content.callinfo': '通話資訊',
  'content.allinsights': '所有洞察',
  'content.availabilityrates': '可用性及費率',
  'content.callback': '回撥',
  'content.close': '關閉',
  'content.sms': '短信',
  'content.timestamp': '時間戳記',
  'content.topics': '主題',
  'content.callingparty': '來電方',
  'content.accountdomain': '帳戶域',
  'content.calledparty': '被叫方',
  'content.recording': '錄音',
  'content.phonesystemoriginationcallid': '電話系統起始通話ID',
  'content.phonesystemterminationcallid': '電話系統結束通話ID',
  'content.uniqueconversationid': '唯一對話ID',
  'content.regenerateinsights': '重新產生洞察',
  'content.customersentiment': '客戶情緒',
  'content.neutral': '中立',
  'content.customerreportedbroadbandoutage':
    '客戶報告寬頻故障，並提供其客戶ID及服務啟用日期以尋求協助。',
  'content.conversationinsights': '對話洞察',
  'content.broadbandoutage': '寬頻故障',
  'content.customeridverification': '客戶ID驗證',
  'content.serviceactivationdate': '服務啟用日期',
  'content.followups': '後續跟進',
  'content.actionneeded': '需要採取行動',
  'content.uniqueConversationId': '唯一對話識別碼',
  'content.uniqueChatId': '唯一聊天識別碼',
  'content.recording&transcript': '錄音與文字記錄',
  'content.chatinsights': '聊天見解',
  'content.visitedpages': '已訪問頁面',
  'content.deviceinfo': '裝置資訊',
  'content.chatstartedonthispage': '此頁已開始聊天',
  'content.prechatinfo': '聊天前資訊',
  'content.notes': '註釋',
  'content.reassign': '重新分配',
  'content.open': '開啟',
  'content.dismiss': '關閉',
  'content.add_placeholder': '新增佔位符值',
  'content.mobile_number': '手提電話號碼',
  'content.please_select': '請選擇',
  'content.sendwhatsapp': '發送 WhatsApp 訊息',

  /* Missed Response */
  'feedback.missed-question': '錯過的問題',
  'feedback.conversation-summary': '對話摘要',
  'feedback.dates-in-spanish': '日期需以西班牙語顯示',
  'feedback.resolve': '解決',
  'feedback.ignore': '忽略',

  //integration
  // zh-HK
  'integration.select_properties': '選擇屬性',
  'integration.select_properties_enabled': '選擇通過此整合啟用的屬性',
  'integration.services_addons': '選擇服務及附加組件',
  'integration.services_visible': '選擇哪些服務及附加組件將顯示於本頁',
  'integration.appearance': '外觀',
  'integration.appearance_customize':
    '選擇你的數碼助理名稱、頭像並設置你的顏色',
  'integration.booking_calendar': '預訂日曆',
  'integration.booking_calendar_style': '選擇預訂日曆彈出視窗樣式',
  'integration.nudges': '提示',
  'integration.nudges_setup': '設置主動消息以吸引用戶訪問者',
  'integration.position': '位置',
  'integration.position_control': '控制聊天小工具在你網站上的位置',
  'integration.custom_fonts': '自訂字體',
  'integration.custom_fonts_upload': '上傳你希望在頁面上使用的自訂字體',
  'integration.custom_css': '自訂 CSS',
  'integration.custom_css_usage': '使用 CSS 定制你的數碼簡編',
  'integration.location': '位置',
  'integration.location_embed': '添加你的嵌入位置 URL',
  'integration.external_links': '外部連結',
  'integration.external_links_add': '添加你的連結',
  'integration.language': '語言',
  'integration.widget_languages': '選擇聊天小工具的語言',
  'integration.chatbot_contact': '聊天機械人',
  'integration.chatbot_enable': '啟用你的數碼助理',
  'integration.chatbot_security': '保持你的 Messenger 安全',
  'integration.chatbot_trusted_pages': '列出可信頁面以顯示聊天機械人',
  'integration.chatbot_publish': '發布你的數碼助理',
  'integration.chatbot_install': '複製代碼片段以安裝你的數碼助理',
  'integration.google_analytics': 'Google Analytics 追蹤',
  'integration.google_analytics_desc':
    '使用 GA4 追蹤 Web Widget 中的使用者活動、工作階段及關鍵操作。',
  'integration.enable_ga4': '啟用 Google Analytics',
  'integration.ga4_measurement_id': 'GA4 衡量 ID',
  'integration.ga4_id_example': '範例：G-ABCD123456',
  'integration.track_events': '追蹤事件',
  'integration.track_events_desc': '選擇要作為 GA4 事件發送的使用者操作。',
  'integration.avatar_click': '頭像點擊',
  'integration.avatar_click_desc': '在使用者點擊聊天頭像時追蹤。',
  'integration.nudge_click': '提示點擊',
  'integration.menu_click': '選單點擊',
  'integration.menu_click_desc': '在使用者開啟 Web Widget 選單時追蹤。',
  'integration.chat_started': '聊天開始',
  'integration.chat_started_desc': '每個工作階段僅追蹤一次使用者的第一則訊息。',
  'integration.event_tag': '事件標籤',
  'integration.event_prefix': '事件前綴',
  'integration.final_tag': '最終標籤',
  'integration.example_event': '事件範例',
  'integration.once_per_session': '每個工作階段僅一次',
  'integration.saving': '儲存中...',
  'integration.save_ga4_settings': '儲存 GA4 設定',

  'guest-messaging.settings': '設定',
  'guest-messaging.outreach-setup': '外展設置',
  'guest-messaging.reservations': '預訂',
  'guest-messaging.insights_logs': '洞察與日誌',
  'guest-messaging.placeholder': '客人訊息模組即將上線。',
  'guest-messaging.settings.placeholder': '配置客人訊息偏好。',
  'guest-messaging.outreach.placeholder': '設置外展活動和模板。',
  'guest-messaging.reservations.placeholder': '管理與預訂相關的訊息。',
  'guest-messaging.reservation-source': '預訂數據來源',
  'guest-messaging.communication-channels': '溝通渠道',
  'guest-messaging.templates': '模板',
  'guest-messaging.link': '連結',
  'guest-messaging.business-profile': '企業檔案',
};
export default chMessages;
